import React__default from 'react';
import { Button } from 'react-aria-components';
import { Button as Button$1 } from './Button.js';
import { Tag } from './Tag.js';
import './Chip.scss';

const Chip = ({ className, onPress, onClose, size = 'medium', appearance = 'solid', disabled = false, closeButtonDisabled = false, children, }) => {
    const content = (React__default.createElement(Tag, { "data-rev-component": 'chip', className: className, indicator: false, size: 'large', appearance: appearance }, children));
    const wrappedContent = onPress ? (React__default.createElement(Button, { className: 'chip-content-button--rev', onPress: onPress, isDisabled: disabled }, content)) : (content);
    return (React__default.createElement("div", { "data-rev-component": 'chip', "data-rev-size": size, "data-rev-has-close-button": !!onClose, "data-rev-appearance": appearance },
        wrappedContent,
        onClose && (React__default.createElement(Button$1, { className: 'chip-close-button--rev', onPress: onClose, size: 'icon', variant: 'ghost', isDisabled: closeButtonDisabled },
            React__default.createElement(CloseIcon, null)))));
};
const CloseIcon = () => {
    return (React__default.createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: '20', height: '21', viewBox: '0 0 20 21', fill: 'none' },
        React__default.createElement("path", { d: 'M7 13.5L13 7.5Z', fill: 'currentColor' }),
        React__default.createElement("path", { d: 'M7 7.5L13 13.5Z', fill: 'currentColor' }),
        React__default.createElement("path", { d: 'M7 13.5L13 7.5M7 7.5L13 13.5', stroke: 'currentColor', strokeLinecap: 'round', strokeLinejoin: 'round' })));
};

export { Chip };
//# sourceMappingURL=Chip.js.map
